export default __webpack_public_path__ + "static/lava-llama-website-screenshot-42ccf3645d2bf6c1891ceb3d4f5c8024.png";